module.exports = __webpack_public_path__ + "img/fond_pave_employeur.e72e7a8.png";